import React, {useEffect, useState} from 'react';
import './FormularioPago.css';
import {useElements, useStripe, PaymentElement} from '@stripe/react-stripe-js';

const FormularioPago = (props) => {
	const {
		factura,
		stripeMessage,
		createPayment,
		enviarYMostrarResultado,
		setActiveStep,
		activeStep,
	} = props;
	const elements = useElements();
	const stripe = useStripe();
	const [message, setMessage] = useState();
	const [cargando, setCargando] = useState(false);
	const [invoice, setInvoice] = useState();

	useEffect(() => {
		async function saveIdFactura() {
			if (factura) {
				try {
					await enviarYMostrarResultado();
					setActiveStep(activeStep + 1);
				} catch {}
			}
		}
		saveIdFactura();
	}, [invoice]);

	const manejarCambios = (ev) => {
		if (ev.complete) {
			document.getElementById('button-form').style.pointerEvents = 'initial';
		} else {
			document.getElementById('button-form').style.pointerEvents = 'none';
		}
	};

	const enviarElements = async (ev) => {
		setCargando(true);
		document.getElementById('button-form').style.pointerEvents = 'none';

		elements.submit();
		const {error, paymentMethod} = await stripe.createPaymentMethod({
			elements,
		});
		let aceptado = await createPayment(paymentMethod.id);

		if (aceptado) {
			setInvoice(factura);
		}

		if (stripeMessage) {
			setCargando(false);
			if (stripeMessage == 'expired_card') {
				setMessage('Su tarjeta ha expirado');
			} else {
				if (stripeMessage == 'processing_error') {
					setMessage('Error de procesamiento');
				} else {
					setMessage('Tarjeta rechazada');
				}
			}
		}
	};

	return (
		<form className='payment-form'>
			<div className='div-form'>
				<label>
					<b>Información de la tarjeta</b>
				</label>
				<hr />
				<PaymentElement onChange={manejarCambios} />
				<div id='mensaje-stripe'>{message}</div>
				<div className='div-button'>
					<div
						id='button-form'
						className='button button-stripe'
						onClick={enviarElements}
					>
						{cargando ? 'Cargando...' : 'Pagar'}
					</div>
				</div>
			</div>
		</form>
	);
};

export default FormularioPago;
